import { LayoutGroup, motion } from "motion/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router";

import { signOut as authSignOut } from "../../features/auth/api";
import { useSession } from "../../features/auth/hooks";

import { isTabActive, TABS } from "./navTabs";

export function DesktopSidebar() {
  const { t } = useTranslation();
  const location = useLocation();
  const { user } = useSession();
  const [signOutError, setSignOutError] = useState(false);

  async function signOut() {
    setSignOutError(false);
    try {
      await authSignOut();
    } catch (err) {
      console.error("[DesktopSidebar] signOut failed", err);
      setSignOutError(true);
    }
  }

  return (
    <div className="flex h-full flex-col gap-2 px-4 py-6">
      <Link to="/" className="px-2 pb-6">
        <div className="text-base font-bold tracking-tight text-volt">VoltaRoute</div>
        <div className="label-caps text-fg-mute">Colombia</div>
      </Link>

      <nav aria-label="Primary" className="flex-1">
        <LayoutGroup>
          <ul className="flex flex-col gap-1">
            {TABS.map((tab) => {
              const active = isTabActive(location.pathname, tab.to);
              return (
                <li key={tab.to}>
                  <Link
                    to={tab.to}
                    aria-current={active ? "page" : undefined}
                    className={`relative flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium ${
                      active ? "text-volt" : "text-fg-mute hover:text-fg"
                    }`}
                  >
                    {active && (
                      <motion.span
                        layoutId="desktop-sidebar-active"
                        className="absolute inset-0 -z-10 rounded-lg bg-volt/15 volt-stroke"
                        transition={{ type: "spring", stiffness: 380, damping: 30 }}
                      />
                    )}
                    <span className="h-5 w-5">{tab.icon}</span>
                    <span>{t(tab.i18nKey)}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </LayoutGroup>
      </nav>

      <div className="mt-auto flex flex-col gap-2 border-t border-line pt-4">
        <Link
          to="/home"
          className="rounded-lg px-3 py-2 text-sm text-fg-mute hover:text-fg"
        >
          {t("nav.drawer_about")}
        </Link>
        {user ? (
          <>
            <div className="truncate px-2 text-xs text-fg-mute" title={user.email ?? undefined}>
              {user.email}
            </div>
            <button
              type="button"
              onClick={signOut}
              className="rounded-lg px-3 py-2 text-left text-sm text-fg-mute hover:text-fg"
            >
              {t("nav.drawer_signout")}
            </button>
            {signOutError && (
              <p className="px-3 text-xs text-ember">{t("profile.signout_failed")}</p>
            )}
            <Link
              to="/settings"
              className="rounded-lg px-3 py-2 text-sm text-fg-mute hover:text-fg"
            >
              {t("nav.settings")}
            </Link>
          </>
        ) : (
          <Link
            to="/auth/login"
            className="rounded-lg px-3 py-2 text-sm text-fg-mute hover:text-fg"
          >
            {t("nav.drawer_signin")}
          </Link>
        )}
      </div>
    </div>
  );
}
